import Myteam from "../../../jsx/components/Dashboard/MyTeam/myteam";

const MyTeamWrapper = () => {
  return <Myteam />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.manager];

export default constore(MyTeamWrapper);
